import { render, staticRenderFns } from "./ImpactstatusSimple.vue?vue&type=template&id=4f667e72&"
import script from "./ImpactstatusSimple.vue?vue&type=script&lang=js&"
export * from "./ImpactstatusSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports